// import React, { useEffect } from "react";
// import "./About_Product_Tabs.css";
// import { Col, Nav, Row, Tab } from "react-bootstrap";
// import PropertiesTab from "./properties_tab/PropertiesTab";
// import ProductDetailsTab from "./product_details_tab/ProductDetailsTab";
// import HealthBenefitsTab from "./health_benefits_tab/HealthBenefitsTab";
// import CommonTabs from "./common_tabs/CommonTabs";
// import { useNavigate } from "react-router-dom";
// import { getProduct } from "../../../features/admin/product/productdetails/Slice";
// import { useDispatch, useSelector } from "react-redux";

// const safetyQualityAsuranceData = [
//   "Made from 100% natural spirulina",
//   " No harmful chemicals or artificial additives",
//   " Produced under quality-controlled conditions",
//   " Safe for daily consumption when taken as directed ",
//   "Always consult a healthcare professional if pregnant, nursing, or under medication",
// ];

// const deliveryData = [
//   "Pan-India delivery available",
//   "Secure and hygienic packaging",
//   "Easy online ordering through our website/app",
//   "Fast dispatch with order tracking support",
// ];

// const howToUseData = [
//   "Take as per the recommended dosage on the label",
//   " Best consumed with water after meals",
//   " Do not exceed the suggested daily intake",
// ];

// const About_Product_Tabs = () => {
//   const dispatch = useDispatch();

//   const productsdetailss = useSelector((state) => state.product.productdetails);

//   // const products = productsdetails?.products;
//   // const productdetail = productsdetails?.products?.productdetails;

//   useEffect(() => {
//     dispatch(getProduct());
//   }, [dispatch]);

//   const navigate = useNavigate();

//   const tabs = [
//     {
//       key: "properties",
//       label: "Properties",
//       component: (
//         <PropertiesTab
//           productsdetailss={productsdetailss?.products?.properties}
//         />
//       ),
//     },

//     {
//       key: "details",
//       label: "Product Details",
//       component: (
//         <ProductDetailsTab
//           // products={products}
//           productsdetailss={productsdetailss?.products?.productdetails}
//         />
//       ),
//     },

//     {
//       key: "benefits",
//       label: "Health Benefits",
//       component: (
//         <HealthBenefitsTab
//           productsdetailss={productsdetailss?.products?.health_benefits}
//         />
//       ),
//     },

//     {
//       key: "safety",
//       label: "Safety & Quality Assurance",
//       component: (
//         <CommonTabs
//           // items={safetyQualityAsuranceData}
//           productsdetailss={
//             productsdetailss?.products?.safety_quality_assurance
//           }
//           field="safety_text"
//         />
//       ),
//     },

//     {
//       key: "how",
//       label: "How To Use",
//       component: (
//         <CommonTabs
//           // items={howToUseData}
//           productsdetailss={productsdetailss?.products?.how_to_use}
//           field="text"
//         />
//       ),
//     },

//     {
//       key: "delivery",
//       label: "Delivery & Availability",
//       component: (
//         <CommonTabs
//           // items={deliveryData}
//           productsdetailss={productsdetailss?.products?.delivery_availability}
//           field="delivery_text"
//         />
//       ),
//     },
//   ];

//   const defaultActiveKey = tabs[0].key;

//   return (
//     <section className="About_Product_Tabs">
//       <div className="container">
//         <div className="main_content">
//           <p className="title">About Spirulina Superfood Supplement</p>

//           <div className="all_tabs_holder">
//             <Tab.Container
//               id="product-tabs"
//               defaultActiveKey={defaultActiveKey}
//             >
//               <Row>
//                 <Col sm={12}>
//                   <Nav className="tabs_holder">
//                     {tabs.map((tab) => (
//                       <Nav.Item key={tab.key}>
//                         <Nav.Link eventKey={tab.key}>{tab.label}</Nav.Link>
//                       </Nav.Item>
//                     ))}
//                   </Nav>
//                 </Col>

//                 <Col sm={12}>
//                   <Tab.Content className="tab_content_holder">
//                     {tabs.map((tab) => (
//                       <Tab.Pane key={tab.key} eventKey={tab.key}>
//                         {tab.component ? (
//                           tab.component
//                         ) : (
//                           <p>{tab.label} content goes here...</p>
//                         )}
//                       </Tab.Pane>
//                     ))}
//                   </Tab.Content>
//                 </Col>
//               </Row>
//             </Tab.Container>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default About_Product_Tabs;
import React, { useEffect, useRef, useState } from "react";
import "./About_Product_Tabs.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faAngleLeft, faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { Col, Nav, Row, Tab } from "react-bootstrap";
import PropertiesTab from "./properties_tab/PropertiesTab";
import ProductDetailsTab from "./product_details_tab/ProductDetailsTab";
import HealthBenefitsTab from "./health_benefits_tab/HealthBenefitsTab";
import CommonTabs from "./common_tabs/CommonTabs";
import { useNavigate } from "react-router-dom";
import { getProduct } from "../../../features/admin/product/productdetails/Slice";
import { useDispatch, useSelector } from "react-redux";

const About_Product_Tabs = () => {
  const dispatch = useDispatch();

  const productsdetailss = useSelector((state) => state.product.productdetails);

  const navigate = useNavigate();

  // Tabs Scroll Ref
  const tabsRef = useRef(null);

  useEffect(() => {
    dispatch(getProduct());
  }, [dispatch]);

  const tabs = [
    {
      key: "properties",
      label: "Properties",
      component: (
        <PropertiesTab
          productsdetailss={productsdetailss?.products?.properties}
        />
      ),
    },

    {
      key: "details",
      label: "Product Details",
      component: (
        <ProductDetailsTab
          productsdetailss={productsdetailss?.products?.productdetails}
        />
      ),
    },

    {
      key: "benefits",
      label: "Health Benefits",
      component: (
        <HealthBenefitsTab
          productsdetailss={productsdetailss?.products?.health_benefits}
        />
      ),
    },

    {
      key: "safety",
      label: "Safety & Quality Assurance",
      component: (
        <CommonTabs
          productsdetailss={
            productsdetailss?.products?.safety_quality_assurance
          }
          field="safety_text"
        />
      ),
    },

    {
      key: "how",
      label: "How To Use",
      component: (
        <CommonTabs
          productsdetailss={productsdetailss?.products?.how_to_use}
          field="text"
        />
      ),
    },

    {
      key: "delivery",
      label: "Delivery & Availability",
      component: (
        <CommonTabs
          productsdetailss={productsdetailss?.products?.delivery_availability}
          field="delivery_text"
        />
      ),
    },
  ];

  // Active Tab State
  const [activeTab, setActiveTab] = useState(tabs[0].key);

  // Scroll Left
  const scrollLeft = () => {
    tabsRef.current.scrollBy({
      left: -200,
      behavior: "smooth",
    });
  };

  // Scroll Right
  const scrollRight = () => {
    tabsRef.current.scrollBy({
      left: 200,
      behavior: "smooth",
    });
  };

  return (
    <section className="About_Product_Tabs">
      <div className="container">
        <div className="main_content">
          <p className="title">About Spirulina Superfood Supplement</p>

          <div className="all_tabs_holder">
            <Tab.Container
              id="product-tabs"
              activeKey={activeTab}
              onSelect={(k) => setActiveTab(k)}
            >
              <Row>
                <Col sm={12}>
                  {/* Tabs Navigation */}
                  <div className="tabs_navigation_wrapper">
                    <button className="scroll_btn" onClick={scrollLeft}>
                      <FontAwesomeIcon icon={faAngleLeft} />
                    </button>

                    <Nav className="tabs_holder" ref={tabsRef}>
                      {tabs.map((tab) => (
                        <Nav.Item key={tab.key}>
                          <Nav.Link eventKey={tab.key}>{tab.label}</Nav.Link>
                        </Nav.Item>
                      ))}
                    </Nav>

                    <button className="scroll_btn" onClick={scrollRight}>
                      <FontAwesomeIcon icon={faAngleRight} />
                    </button>
                  </div>
                </Col>

                <Col sm={12}>
                  <Tab.Content className="tab_content_holder">
                    {tabs.map((tab) => (
                      <Tab.Pane key={tab.key} eventKey={tab.key}>
                        {tab.component}
                      </Tab.Pane>
                    ))}
                  </Tab.Content>
                </Col>
              </Row>
            </Tab.Container>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About_Product_Tabs;
